// extracted by mini-css-extract-plugin
module.exports = {"bgimg":"Maintenance_bgimg__3CEhA","topleft":"Maintenance_topleft__1xKbR","bottomleft":"Maintenance_bottomleft__3ygNU","middle":"Maintenance_middle__1mdxc"};